import React, {useContext, useState} from 'react'
import CartItem from '../components/CartItem/CartItem.jsx'
import {StateContext} from '../context/GlobalState.jsx'
import {GetText} from "../context/text.js";

function Cart() {
    // consuming contexts
    let {total, cartItems, totalItems, resetCart, checkOutCart, courseUSD, lang} = useContext(StateContext);

    let text = GetText();

    const [nameCustomer, setNameCustomer] = useState('Покупатель');
    const [telCustomer, setTelCustomer] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isAgreed, setIsAgreed] = useState(false);

    const newOrder = {
        cartItems: cartItems,
        nameCustomer: nameCustomer,
        telCustomer: telCustomer,
        totalItems: totalItems,
        total: total
    };

    const handleCheckout = () => {
        let phoneErrorMessage = '';
        let agreeErrorMessage = '';

        switch (lang) {
            case 'ua':
                phoneErrorMessage = 'Телефон обов\'язковий для заповнення';
                agreeErrorMessage = 'Потрібно погодитися з договором оферти та політикою конфіденційності';
                break;
            case 'ru':
                phoneErrorMessage = 'Телефон обязателен для заполнения';
                agreeErrorMessage = 'Необходимо согласиться с договором оферты и политикой конфиденциальности';
                break;
            case 'en':
                phoneErrorMessage = 'Phone number is required';
                agreeErrorMessage = 'You must agree to the terms of service and privacy policy';
                break;
            default:
                phoneErrorMessage = 'Phone number is required';
                agreeErrorMessage = 'You must agree to the terms of service and privacy policy';
        }

        if (!telCustomer) {
            setErrorMessage(phoneErrorMessage);
            return;
        }

        if (!isAgreed) {
            setErrorMessage(agreeErrorMessage);
            return;
        }

        setErrorMessage('');
        checkOutCart(newOrder);
    };

    // render JSX
    return (
        <>
            <section className="cart-section">
                {
                    cartItems.map((item) => <CartItem key={item.ID} item={item}/>)
                }

                <div className="summary-detail-cart">
                    {
                        totalItems !== 0 ? (
                            <div className="items">
                                <p>
                                    <input
                                        type="text"
                                        placeholder={text.Cart.namePlaceholder}
                                        required
                                        onChange={e => setNameCustomer(e.target.value)}
                                    />
                                </p>
                                <p>
                                    <input
                                        type="tel"
                                        placeholder={text.Cart.telPlaceholder}
                                        required
                                        value={telCustomer}
                                        onChange={e => setTelCustomer(e.target.value)}
                                    />
                                </p>

                                <div style={{ marginTop: "15px", fontSize: "12px", textAlign: "left" }}>
                                    <label style={{ display: "flex", alignItems: "flex-start", gap: "8px", cursor: "pointer" }}>
                                        <input
                                            type="checkbox"
                                            checked={isAgreed}
                                            onChange={(e) => setIsAgreed(e.target.checked)}
                                            style={{ marginTop: "3px" }}
                                        />

                                        <span>
                                            {lang === 'ua' && (
                                                <>
                                                    Я згоден з{" "}
                                                    <a href="/oferta" target="_blank" rel="noopener noreferrer">
                                                        договором оферти
                                                    </a>{" "}
                                                    та{" "}
                                                    <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
                                                        політикою конфіденційності
                                                    </a>
                                                </>
                                            )}

                                            {lang === 'ru' && (
                                                <>
                                                    Я согласен с{" "}
                                                    <a href="/oferta" target="_blank" rel="noopener noreferrer">
                                                        договором оферты
                                                    </a>{" "}
                                                    и{" "}
                                                    <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
                                                        политикой конфиденциальности
                                                    </a>
                                                </>
                                            )}

                                            {lang === 'en' && (
                                                <>
                                                    I agree to the{" "}
                                                    <a href="/oferta" target="_blank" rel="noopener noreferrer">
                                                        terms of service
                                                    </a>{" "}
                                                    and{" "}
                                                    <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
                                                        privacy policy
                                                    </a>
                                                </>
                                            )}
                                        </span>
                                    </label>
                                </div>

                                {errorMessage && <p style={{color: 'red', marginTop: '10px'}}>{errorMessage}</p>}
                            </div>
                        ) : (
                            <div className="items"></div>
                        )
                    }

                    <div className="items padTop">
                        {
                            totalItems === 0 ? <h4 className="warn-txt">{text.Cart.noItem}</h4> :
                                <h4>{text.Cart.totalItems}: {totalItems}</h4>
                        }
                    </div>

                    <div className="amounts">
                        { lang === "ua" && <h4>{text.Cart.total}: {total * courseUSD} грн</h4> }
                        { lang === "ru" && <h4>{text.Cart.total}: {total * courseUSD} грн</h4> }
                        { lang === "en" && <h4>{text.Cart.total}: {total * courseUSD} UAH</h4> }
                    </div>

                    {
                        totalItems > 0 && (
                            <>
                                <button
                                    onClick={handleCheckout}
                                    className="checkout"
                                >
                                    {text.Cart.checkout}
                                </button>
                                <button onClick={() => resetCart()} className="reset">
                                    {text.Cart.reset}
                                </button>
                            </>
                        )
                    }
                </div>
            </section>
        </>
    );
}

export default Cart;